import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      paddingBlock: 10,
      position: 'relative',
      cursor: 'pointer',

      '&:hover  $avatarIcon': {
        fill: 'var(--x-accent-1-1)',
      },
    },

    menu: {
      background: '#fff',
      borderRadius: 8,
      display: 'flex',
      gap: 8,
      flexDirection: 'column',
      listStyleType: 'none',
      padding: 20,
      position: 'absolute',
      width: 208,
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.24)',
    },

    avatar: {
      alignItems: 'center',
      display: 'flex',
      gap: 8,
    },

    avatarIcon: {
      fill: '#C9C9C9',
      width: 14,
      height: 14,
    },

    name: {
      wordBreak: 'break-word',
    },

    arrowContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },

    grow: {
      flexGrow: 1,
    },

    row: {
      alignItems: 'center',
      display: 'flex',
      gap: 24,
      paddingBlock: 8,
    },

    text: {
      color: 'var(--texts-tint-1, #4C4C4C)',

      '&:hover $row': {
        color: 'var(--x-accent-1-1)',
      },
    },

    icon: {
      fill: '#4C4C4C',
      height: 24,
      width: 24,
    },
  },
  { name: 'Profile' },
);
